export type OrgAuthLoginField = "email" | "password";

export type OrgAuthLoginFieldErrors = Partial<Record<OrgAuthLoginField, string>>;

export interface OrgAuthLoginValidationResult {
    fieldErrors: OrgAuthLoginFieldErrors;
    normalizedEmail: string;
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateOrgAuthLoginForm(email: string, password: string): OrgAuthLoginValidationResult {
    const normalizedEmail = email.trim();
    const fieldErrors: OrgAuthLoginFieldErrors = {};

    if (!normalizedEmail) {
        fieldErrors.email = "Enter the email address for your console account.";
    } else if (!EMAIL_PATTERN.test(normalizedEmail)) {
        fieldErrors.email = "Enter a valid email address, for example you@example.com.";
    }

    if (!password) {
        fieldErrors.password = "Enter your password to continue.";
    }

    return {
        fieldErrors,
        normalizedEmail
    };
}

export function hasOrgAuthLoginFieldErrors(fieldErrors: OrgAuthLoginFieldErrors): boolean {
    return Boolean(fieldErrors.email || fieldErrors.password);
}

export interface OrgAuthForgotPasswordValidationResult {
    emailError: string | null;
    normalizedEmail: string;
}

/** Email-only validation for the forgot-password form. */
export function validateOrgAuthForgotPasswordEmail(email: string): OrgAuthForgotPasswordValidationResult {
    const normalizedEmail = email.trim();

    if (!normalizedEmail) {
        return {
            emailError: "Enter the email address for your console account.",
            normalizedEmail
        };
    }
    if (!EMAIL_PATTERN.test(normalizedEmail)) {
        return {
            emailError: "Enter a valid email address, for example you@example.com.",
            normalizedEmail
        };
    }

    return { emailError: null, normalizedEmail };
}
